import { Flex, Heading, Box, Text, Image } from '@chakra-ui/react'

interface ProductResultProps {
	productImage: string
	productHeader: string
	productDescription: string
}
const ProductResult: React.FC<ProductResultProps> = ({
	productImage,
	productHeader,
	productDescription,
}) => {
	return (
		<Flex
			height={{ base: '14rem', md: '11rem' }}
			flexDir={{ base: 'column-reverse', md: 'column' }}
			align={'center'}
			rowGap="1.5rem"
			width={{ base: '55%', md: 'unset' }}
			justify={{
				base: 'space-between',
				md: undefined,
			}}
		>
			<Heading
				display={{
					base: 'none',
					md: 'initial',
				}}
				size="lg"
			>
				Product
			</Heading>
			<Image
				objectFit={'cover'}
				height={{
					base: '10rem',
					md: '10rem',
				}}
				src={productImage}
			/>
			<Box
				fontSize={{
					base: 'sm',
					md: 'xl',
				}}
			>
				<Text fontWeight={'bold'}> {productHeader}</Text>
				<Text textAlign={'center'}>{productDescription}</Text>
			</Box>
		</Flex>
	)
}

export default ProductResult
